export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';

export const showErrorNotification = ( message ) => ({
    type: SHOW_ERROR_NOTIFICATION,
    payload: { message },
});
